import { List, Datagrid, TextField, BooleanField, FunctionField } from 'react-admin';

export const DRResponseList = props => (
  <List {...props} title="DR Quiz Responses" sort={{ field: 'submitted_at', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="participant_name" label="Participant" />
      <TextField source="website_name" label="Website" />
      <TextField source="question_title" label="Question" />
      <BooleanField source="tm_related" label="TM-related" />
      <FunctionField
        label="Selected Answer"
        render={record => record.selected_idx !== null ? `Option ${record.selected_idx + 1}` : '—'}
      />
      <FunctionField
        label="Correct"
        render={record => {
          if (record.is_correct === null || record.is_correct === undefined) return '—';
          return record.is_correct ? '✓' : '✗';
        }}
      />
      <BooleanField source="timed_out" label="Timed Out" />
      <FunctionField
        source="submitted_at"
        label="Submitted At"
        render={record =>
          record.submitted_at
            ? new Date(record.submitted_at).toLocaleString(undefined, { timeZoneName: 'shortOffset' })
            : '—'
        }
      />
    </Datagrid>
  </List>
);
